import * as React from "react";
import { IDataCenter } from "../../vm";
import { Card, ICardTokens } from "@uifabric/react-cards";
import { Stack, Text } from "office-ui-fabric-react";
import { GS } from "../../utils/Styles";

export interface DataCenterCardProps {
  dataCenter: IDataCenter;
  viewDataCenter: Function;
}

const DataCenterCard: React.FC<DataCenterCardProps> = ({
  dataCenter,
  viewDataCenter,
}) => {
  const cardTokens: ICardTokens = { childrenMargin: 12 };
  return (
    <Card
      className="ms-motion-scaleDownIn card-width datacenter-card"
      horizontal
      styles={{ root: { ...GS.bgWhite } }}
      tokens={cardTokens}
    >
      <Card.Section grow={1}>
        <Stack
          className="pointer cardItem ml-10"
          styles={{ root: { width: "100%", height: "85px" } }}
          onClick={() => viewDataCenter(dataCenter)}
        >
          <Text className="datacenter-card-title">
            {dataCenter.name && dataCenter.name}
          </Text>
          <Text className="datacenter-card-location">
            {dataCenter.location && dataCenter.location}{" "}
          </Text>
          {/* <Text className="datacenter-card-zipcode">
            {dataCenter.zipCode ? dataCenter.zipCode : ""}{" "}
          </Text> */}
        </Stack>
      </Card.Section>
    </Card>
  );
};

export default DataCenterCard;
